/** Match the existing notification bots, without depending on the v1 HTML globals. */
export function telegramNotificationUrl({
  verificationKey,
  botName,
  dotCom,
  development,
}: {
  verificationKey: string;
  botName?: string;
  dotCom: boolean;
  development: boolean;
}): string | null {
  if (!verificationKey) return null;
  const bot =
    botName ||
    (development ? 'TestSantaSecretRuBot' : dotCom ? 'SantaSecretDotComBot' : 'SantaSecretRuBot');
  return `https://t.me/${bot}?start=${encodeURIComponent(verificationKey)}`;
}
